<template>
  <g>
    <circle :cx="center" :cy="center" :r="radius" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <circle :cx="center" :cy="center" :r="radiusBorder" stroke="#ddd" stroke-width="1" fill="none" />
      <polygon :points="sides.a.border.corner.start" :transform="sides.a.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
      <polygon :points="sides.a.border.corner.end" :transform="sides.a.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
      <rect :x="sides.a.labelBackground.x" :y="sides.a.labelBackground.y" :width="sides.a.labelBackground.width" :height="sides.a.labelBackground.height" style="fill:#fff" />
      <rect :x="sides.a.border.rect.x" :y="sides.a.border.rect.y" :width="sides.a.border.rect.width" :height="sides.a.border.rect.height" style="fill:#fff" />
    </g>
    <text dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="sides.a.labelSpace.x" :y="sides.a.labelSpace.y" class="font-weight-bold" font-size="1em">{{sides.a.name}}</tspan>
      <tspan v-if="formComplete" :x="sides.a.labelSpace.x" dy="1.5em" font-size="0.7em">{{sides.a.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="sides.a.labelSpace.x" dy="1em" font-size="0.7em">{{sides.a.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-if="sides.a.rand === rand.saum.titleSaum.name">
        <circle :cx="sides.a.saum.center" :cy="sides.a.saum.center" :r="sides.a.saum.radius" stroke="#b1b1b1" stroke-width="1" stroke-dasharray="3,3" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
        <g v-if="activeOesenArt">
          <circle v-for="(item, index) in sides.a.oesenAnzahl" :key="index" :cx="sides.a.oesenAbstand.x(index, sides.a.oesenAnzahl)" :cy="sides.a.oesenAbstand.y(index, sides.a.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
        </g>
      </g>
      <circle v-if="sides.a.rand === rand.hohlsaum.title.name" :cx="sides.a.hohlsaum.center" :cy="sides.a.hohlsaum.center" :r="sides.a.hohlsaum.radius" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      center: 350 / 2 + 75,
      radius: 350 / 2,
      radiusBorder: 350 / 2 + 40
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            radius: 350 / 2 - 15,
            center: 350 / 2 + 75,
            x: function (i, item) {
              return Math.cos(((360 / item) * (Math.PI / 180)) * i) * this.radius + this.center
            },
            y: function (i, item) {
              return Math.sin(((360 / item) * (Math.PI / 180)) * i) * this.radius + this.center
            }
          },
          saum: {
            center: this.center,
            radius: this.radius - 30
          },
          hohlsaum: {
            center: this.center,
            radius: this.radius - 9
          },
          labelSpace: {
            x: 35,
            y: 238
          },
          labelBackground: {
            x: 0,
            y: 220,
            width: 70,
            height: 60
          },
          border: {
            rect: {
              x: 460,
              y: 249,
              width: 10,
              height: 2
            },
            corner: {
              start: '465,248 460,238 470,238',
              rotateStart: 'rotate(-2, 465, 248)',
              end: '465,252 460,262 470,262',
              rotateEnd: 'rotate(2, 465, 252)'
            }
          },
          id: 1
        }
      }
    }
  }
}
</script>

<style>
</style>
